import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { EventAudienceFilter, EventTimeFilter } from "@upsquad/shared";

interface EventState {
	activeTab: EventAudienceFilter;
	timeFilter: EventTimeFilter;
	selectedDate: string | null;
}

const initialState: EventState = {
	activeTab: EventAudienceFilter.ALL,
	timeFilter: EventTimeFilter.UPCOMING,
	selectedDate: null,
};

export const eventSlice = createSlice({
	name: "event",
	initialState,
	reducers: {
		setEventActiveTab(state, action: PayloadAction<EventAudienceFilter>) {
			state.activeTab = action.payload;
		},
		setEventTimeFilter(state, action: PayloadAction<EventTimeFilter>) {
			state.timeFilter = action.payload;
		},
		setEventSelectedDate(state, action: PayloadAction<string | null>) {
			state.selectedDate = action.payload;
		},
	},
});

export const { setEventActiveTab, setEventTimeFilter, setEventSelectedDate } = eventSlice.actions;
